import Vue from 'vue'

// site-api POST /api/v2/sites/:siteId/audio-signals (CHEKT-2713 / CHEKT-2668)
// Reports an app intercom/talk session so site-api can publish twoWayTalkdownInitiated
// to the ADC event gateway for ADC-linked sites. Same body contract as the dealer endpoint MP uses.
export default {
  apiPrefix: '/api/v2/sites',
  postAudioSignal: function ({siteId, action, state = 'start', deviceType = 'camera', deviceId, channel}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/audio-signals`
    let data = {
      action: action,
      state: state,
      device_type: deviceType,
      device_id: Number(deviceId),
    }
    if (deviceType === 'ipspeaker') data.channel = channel

    return Vue.http.post(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader(10 * 1000))
  },
}
